import { useMemo } from 'react';

import { useAuthSession } from '../contexts/AuthContext.jsx';
import { useDemoMode } from '../contexts/DemoModeContext.jsx';
import { useRole } from '../contexts/RoleContext.jsx';

/**
 * Authentication hook.
 *
 * Two-mode resolver:
 *
 *   - Demo mode (?demo=true): user is synthesized from RoleContext +
 *     seed data so the persona switcher in the sidebar works instantly.
 *   - Live mode: user is the decoded JWT payload fetched by AuthContext
 *     from /api/re/auth/me.
 */
export function useAuth() {
  const isDemo = useDemoMode();
  const { role, currentUser } = useRole();
  const session = useAuthSession();

  return useMemo(() => {
    if (isDemo || !session.user) {
      return {
        isAuthenticated: isDemo ? true : session.isAuthenticated,
        user: {
          id: currentUser?.id || 'dev-user',
          org_id: 'org-smith-luxury',
          name: currentUser?.name || 'Demo User',
          email: currentUser?.email || 'demo@atlacis.app',
          role,
          product_access: ['real_estate'],
        },
        logout: session.logout,
      };
    }
    return {
      isAuthenticated: true,
      user: {
        id: session.user.id,
        org_id: session.user.org_id,
        name: session.user.name,
        email: session.user.email,
        role: session.user.role,
        product_access: ['real_estate'],
      },
      logout: session.logout,
    };
  }, [isDemo, role, currentUser, session]);
}
